import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getRoomSizeDataWithId, updateRoomSize } from "adminApi/RoomSizeApi/RoomSize";
import { RoomSizeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditRoomSizeForm from "./Componates/EditRoomSizeForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { validateForm } from "utils/validation";
import fields from "../json/RoomSizeFields.json";

const EditRoomSize = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, RoomSizeRules);

  // Fetch existing record by ID and populate form
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoomSizeDataWithId, setValues);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send plain JSON — no file uploads in this form
    async (formValues) => await updateRoomSize({ id, data: formValues }),
    (vals) => {
      const err = validateForm(vals, RoomSizeRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Room Size updated successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditRoomSizeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default EditRoomSize;
